import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import AppBreadcrumb from "../../components/template/BreadCrumb/AppBreadcrumb";
import MetaInformation from "../../utils/meta/MetaInformation";
import ProductsData from "../home/Products/productsData";
import ProductsGallery from "./Model/ProductsGallery";
import { ProductsGalleryArray } from "./Model/ProductsGalleryData";
import "./style.scss";

const ProductDetail = () => {
  const [show, setShow] = useState(false);
  const [subProducts, setSubProducts] = useState([]);
  const [image_Array, setImage_Array] = useState(
    ProductsGalleryArray.slice(0, 5)
  );
  const [selectedImageId, setSelectedImageId] = useState(null);
  const arrayLength = ProductsGalleryArray.length;
  const params = useParams();
  const productKey = params.productKey;

  useEffect(() => {
    const product = ProductsData?.find((product) => {
      return product.key === productKey;
    });

    setSubProducts(product.products);
  }, [subProducts, productKey]);

  const handleSelectedImage = (id) => {
    if (id > arrayLength - 2) {
      if (id === arrayLength) {
        setImage_Array(() => [
          ...ProductsGalleryArray.slice(id - 3),
          ...ProductsGalleryArray.slice(0, 2),
        ]);
      } else if (id === arrayLength - 1) {
        setImage_Array(() => [
          ...ProductsGalleryArray.slice(id - 3),
          ...ProductsGalleryArray.slice(0, 1),
        ]);
      }
    } else if (id < 3) {
      if (id === 1) {
        setImage_Array(() => [
          ...ProductsGalleryArray.slice(-2),
          ...ProductsGalleryArray.slice(0, 3),
        ]);
      } else if (id === 2) {
        setImage_Array(() => [
          ...ProductsGalleryArray.slice(-1),
          ...ProductsGalleryArray.slice(0, 4),
        ]);
      }
    } else {
      setImage_Array(() => ProductsGalleryArray.slice(id - 3, id + 2));
    }
    setSelectedImageId(id);
    setShow(true);
  };

  return (
    <>
      <MetaInformation
        title={`${productKey} - HERZMANN`}
        name="Product details route"
        content={`Showing details of ${productKey}`}
      />
      <AppBreadcrumb />

      {show && (
        <ProductsGallery
          setShow={setShow}
          show={show}
          selectedImageId={selectedImageId}
          image_Array={image_Array}
        />
      )}

      {productKey === "Structure-&-Wall-Surface" ? (
        <div className="container mb-5">
          {subProducts?.map((product, index) => {
            return (
              <div key={index}>
                <div className="mt-5">
                  <div>
                    <h4 className="fw-bold">{product.title}</h4>

                    {product.description?.map((item, index) => {
                      return (
                        <p key={index} className="description-text">
                          {item}
                        </p>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <div className="d-flex justify-content-around flex-wrap">
                    {product.imagesData?.map((data, index) => {
                      return (
                        <div className="mb-3" key={index}>
                          <Card
                            className="gallery-flex-container"
                            border="light"
                          >
                            <Card.Img
                              variant="top"
                              src={data.image}
                              height={200}
                              width={200}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSelectedImage(data.id)}
                            />
                          </Card>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="container mb-5" style={{ minHeight: "70vh" }}>
          {subProducts?.map((product, index) => {
            return (
              <div className="mt-5" key={index}>
                <div>
                  <h4 className="fw-bold">{product.title}</h4>
                  {Array.isArray(product.description) &&
                    product.description?.map((item, index) => {
                      return (
                        <p className="description-text" key={index}>
                          {item}
                        </p>
                      );
                    })}
                </div>

                <div className="d-flex justify-content-around flex-wrap">
                  {product.imagesData?.map((item, index) => {
                    return (
                      <div key={index}>
                        <div className="product-container d-flex justify-content-center align-items-center">
                          <img src={item.image} alt="universalSocketImage" />
                        </div>
                        <p className="text-center mt-2">{item.title}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ProductDetail;
